import { Directive, HostListener, inject, input } from '@angular/core';
import { EventType, GA4Event, GTMService } from '@personal-area/global/gtm';

@Directive({
  selector: '[pagGaEventClick]',
  standalone: true,
})
export class GaEventClickDirective {
  name = input.required<EventType>({ alias: 'pagGaEventClick' });
  gaEventOptions = input.required<Partial<GA4Event>>();

  private readonly _gtmService = inject(GTMService)

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    this._gtmService.event(this.name(), {
      action: 'click',
      context: 'new',
      object: 'link',
      ...this.gaEventOptions(),
    });
  }
}
